import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    Grid,
    FormHelperText,
    Icon,
    Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Scrollbars from "rc-scrollbars";
import { InputBaseField, SelectField } from "../../../../../../../components/InputField/InputField";
import { Label } from "../../../../../../../components/UiElements/UiElements";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../../../components/Message/Alert";
import addDonorIcon from "../../../../../../../assets/img/addIcon.svg";
import { PostDataAPI } from "../../../../../../../Services/APIService";
import DialogLoader from "../../../../../../../components/Loader/DialogLoader";

function AddCashDisbursement({ handleClose, handleSuccessClose, isOpen, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    /* =======================
       STATE
    ======================= */

    const [state, setState] = useState({
        programId: "",
        disbursementNotes: ""
    });

    const [items, setItems] = useState([
        { itemName: "", qty: "", rate: "", disbursedDate: "" }
    ]);

    const [lstProgram, setLstProgram] = useState([{
        label: 'Choose Program',
        value: ''
    }]);
    const [isLoading, setIsLoading] = useState(false);

    const [errors, setErrors] = useState({
        programId: false,
        items: []
    });

    /* =======================
       LOAD PROGRAMS
    ======================= */

    useEffect(() => {
        loadProgram();
    }, []);

    const loadProgram = () => {
        PostDataAPI("fdngrantprograms/loadGrid").then((result) => {
            if (result.success && result.data) {
                setLstProgram(prev => [
                    ...prev,
                    ...result.data.map(t => ({
                        label: t.name,
                        value: t.programId
                    }))
                ]);

            }
        });
    };

    /* =======================
       HANDLERS
    ======================= */

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
    };

    const handleItemChange = (index, field, value) => {
        setItems((prev) => {
            const updated = [...prev];
            updated[index][field] = value;
            return updated;
        });
    };

    const addItem = () => {
        setItems((prev) => [
            ...prev,
            { itemName: "", qty: "", rate: "", disbursedDate: "" }
        ]);
    };

    const deleteItem = (index) => {
        setItems((prev) => prev.filter((_, i) => i !== index));
    };

    /* =======================
       VALIDATION
    ======================= */

    const validateForm = () => {
        let valid = true;
        let itemErrors = [];

        if (!state.programId) {
            valid = false;
            setErrors((p) => ({ ...p, programId: true }));
        } else {
            setErrors((p) => ({ ...p, programId: false }));
        }

        items.forEach((item, index) => {
            let err = {};
            if (!item.itemName) err.itemName = true;
            if (!item.qty || isNaN(item.qty)) err.qty = true;
            if (!item.rate || isNaN(item.rate)) err.rate = true;
            if (!item.disbursedDate) err.disbursedDate = true;

            if (Object.keys(err).length > 0) valid = false;
            itemErrors[index] = err;
        });

        setErrors((p) => ({ ...p, items: itemErrors }));
        return valid;
    };

    /* =======================
       SUBMIT
    ======================= */

    const addInKind = () => {
        if (!validateForm()) return;

        setIsLoading(true);

        const formData = new FormData();

        // Simple fields
        formData.append("programId", state.programId);
        formData.append(
            "inKindDisbursementNotes",
            state.disbursementNotes || ""
        );
        formData.append("status", "Pending Approval");


        items.forEach((i, index) => {
            formData.append(
                `details[${index}].itemName`,
                i.itemName
            );

            formData.append(
                `details[${index}].qty`,
                i.qty
            );

            formData.append(
                `details[${index}].rate`,
                i.rate
            );

            formData.append(
                `details[${index}].disbursedDate`,
                new Date(i.disbursedDate).toISOString()
            );
        });

  

        PostDataAPI("fdngrantinkinddisbursement/add", formData).then((result) => {
            setIsLoading(false);
            if (result.success) {
                handleSuccessClose("In-kind disbursement added successfully");
            }
        });
    };

    /* =======================
       RENDER
    ======================= */

    return (
        <Dialog maxWidth="md" open={isOpen} onClose={handleClose}>
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>
                            Cash Disbursement
                        </Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                </div>
            </div>

            {isLoading ? <DialogLoader></DialogLoader> : ""}

            <Scrollbars autoHeight autoHeightMax={570}>
                <div className={classes.content}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <Label title="Choose Program" />
                            <SelectField
                                options={lstProgram}
                                name="programId"
                                value={state.programId}
                                onChange={handleChange}
                            />
                            {errors.programId && (
                                <FormHelperText error>
                                    Program is required
                                </FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Label title="Disbursement Purpose" />
                            <InputBaseField
                                name="disbursementNotes"
                                onChange={handleChange}
                                placeholder="Purpose of disbursement"
                            />
                        </Grid>
                    </Grid>

                    <h3 className={classes.inkindDetail}>In-kind Gift Details</h3>

                    {items.map((item, index) => (
                        <div className={classes.FlexMain} key={index}>
                            <div className={classes.FlexField}>
                                <InputBaseField
                                    placeholder="Item Name"
                                    value={item.itemName}
                                    onChange={(e) =>
                                        handleItemChange(index, "itemName", e.target.value)
                                    }
                                />
                                {errors.items?.[index]?.itemName && (
                                    <FormHelperText error>Required</FormHelperText>
                                )}
                            </div>
                            <div className={classes.FlexField}>
                                <InputBaseField
                                    placeholder="Qty"
                                    type={'number'}
                                    value={item.qty}
                                    onChange={(e) =>
                                        handleItemChange(index, "qty", e.target.value)
                                    }
                                />
                                {errors.items?.[index]?.qty && (
                                    <FormHelperText error>Valid qty required</FormHelperText>
                                )}
                            </div>
                            <div className={classes.FlexField}>

                                <InputBaseField
                                    placeholder="Cost"
                                    type={'number'}
                                    value={item.rate}
                                    onChange={(e) =>
                                        handleItemChange(index, "rate", e.target.value)
                                    }
                                />
                                {errors.items?.[index]?.rate && (
                                    <FormHelperText error>Valid cost required</FormHelperText>
                                )}
                            </div>
                            <div className={classes.FlexField}>
                                <InputBaseField
                                    type="date"
                                    value={item.disbursedDate}
                                    onChange={(e) =>
                                        handleItemChange(index, "disbursedDate", e.target.value)
                                    }
                                />
                                {errors.items?.[index]?.disbursedDate && (
                                    <FormHelperText error>Date required</FormHelperText>
                                )}
                            </div>

                            {index === items.length - 1 && (
                                <img
                                    src={addDonorIcon}
                                    className={classes.AddIcon}
                                    onClick={addItem}
                                    alt="Add"
                                />
                            )}

                            {index > 0 && (
                                <img
                                    src={addDonorIcon}
                                    className={classes.AddIconDelete}
                                    onClick={() => deleteItem(index)}
                                    alt="Delete"
                                />
                            )}


                        </div>
                    ))}
                </div>
            </Scrollbars>

            <div className={classes.footer}>
                <div className={classes.footerRight}>
                    <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                    <Button className={classes.changeBtn} onClick={addInKind}>Add New </Button>

                </div>
            </div>
        </Dialog>
    );
}

export default withSnackbar(AddCashDisbursement);
